import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@app/common/app-tokens';
import { Store } from '@app/common/store';
import { InternetStatus } from '@app/models/internet-status';
import { fromEvent } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InternetStatusService extends Store<InternetStatus> {

  constructor(@Inject(WINDOW) private window: Window) {
    super({ online: window.navigator.onLine });
  }

  whenOnline() {
    return fromEvent(this.window, 'online')
      .pipe(
        tap(() => {
          this.setState({ online: true });
        }));
  }

  whenOffline() {
    return fromEvent(this.window, 'offline')
      .pipe(
        tap(() => {
          this.setState({ online: false });
        }));
  }
}
